import { render, staticRenderFns } from "./SwitchMapNijmegen.vue?vue&type=template&id=d1a3823c&"
import script from "./SwitchMapNijmegen.vue?vue&type=script&lang=js&"
export * from "./SwitchMapNijmegen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports